import React, { useMemo, useRef } from 'react';

import CarouselReviewCard from '@rover/components/src/cards/CarouselReviewCard/';
import PaginationWrapper, {
  Props as PaginationWrapperProps,
} from '@rover/react-lib/src/components/lists/Carousel/PaginationWrapper';
import SnappingCarousel from '@rover/react-lib/src/components/lists/Carousel/SnappingCarousel';

type CarouselReviewCardProps = React.ComponentProps<typeof CarouselReviewCard>;

export type Review = CarouselReviewCardProps['review'] & { url: string };

type Props = {
  reviews: Review[];
  onCardViewed?: (index: number) => void;
  cardProps?: Omit<CarouselReviewCardProps, 'review' | 'rootCarouselRef' | 'onViewed'>;
} & Omit<PaginationWrapperProps, 'children'>;

const ReviewsCarousel: React.FC<Props> = ({ reviews, onCardViewed, cardProps, ...props }) => {
  const ref = useRef<HTMLDivElement>();

  const reviewCards = useMemo(
    () =>
      reviews.map((review, index) => (
        <CarouselReviewCard
          key={review.url}
          review={review}
          rootCarouselRef={ref}
          onViewed={onCardViewed ? () => onCardViewed(index) : undefined}
          {...cardProps}
        />
      )),
    [cardProps, onCardViewed, reviews]
  );

  return (
    <PaginationWrapper {...props}>
      <SnappingCarousel>{reviewCards}</SnappingCarousel>
    </PaginationWrapper>
  );
};

export default ReviewsCarousel;
